module.exports = __webpack_public_path__ + "img/banner-popup-aviso-fraude.adcf9794.webp";